import { capitalize } from 'lodash';

export default {
  params: ['typeOfUse', 'vehicleTypeOfUseRequiredDrivers', 'productName'],
  validate: (value, { typeOfUse, vehicleTypeOfUseRequiredDrivers }) => {
    if (vehicleTypeOfUseRequiredDrivers.includes(typeOfUse)) {
      return {
        required: true,
        valid: value,
      };
    }
    return {
      required: true,
      valid: value !== null,
    };
  },
  message: (fieldName, { _value_: v, typeOfUse, vehicleTypeOfUseRequiredDrivers, productName }) => {
    if (vehicleTypeOfUseRequiredDrivers.includes(typeOfUse)) {
      const detailsName = ['motorhome'].includes(productName) ? `${capitalize(productName)}` : 'Vehicle';

      return productName === 'bike'
        ? 'You have specified that another rider uses the vehicle for business purposes. Please select \'Yes\' to add details of the additional rider(s) or select a different type of use below on this page.'
        : `You have specified that another driver uses the vehicle for business purposes. Please select 'Yes' to add details of the additional driver(s) or go to the '${detailsName} Details' step to select a different usage type.`;
    }
    return 'Please specify if you want to include an additional driver to your car insurance.';
  },
  computesRequired: true,
};
